/** Iter XX.223 — Plus Conversion v1 client library. */
const _base = () => process.env.REACT_APP_BACKEND_URL;
function _auth() {
  const t = (typeof window !== "undefined" && window.localStorage)
    ? window.localStorage.getItem("gully_token") : null;
  return t ? { Authorization: `Bearer ${t}` } : {};
}
async function _fetch(path, opts = {}) {
  const r = await fetch(`${_base()}/api/plus_conversion${path}`, {
    ...opts, headers: { "Content-Type": "application/json", ..._auth(),
                         ...(opts.headers || {}) },
  });
  if (r.status === 404) return { _disabled: true };
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body?.detail || `HTTP ${r.status}`);
  return body;
}
export async function fetchCounters() {
  try { const r = await _fetch("/counters"); return r._disabled ? null : r; }
  catch { return null; }
}
export async function fetchReturnMemory() {
  try { const r = await _fetch("/return_memory"); return r._disabled ? null : r; }
  catch { return null; }
}
export async function trackConversionEvent(payload) {
  try { return await _fetch("/event", { method: "POST", body: JSON.stringify(payload) }); }
  catch { return { ok: false }; }
}
